<template>
  <fragment>
    <div class="col-md-4">
      <div class="card card_content shadow-sm p-4">
        <p
          class="text-left small text-uppercase p-2 pb-3 d-flex justify-content-start align-items-center"
        >
          <i class="material-icons">person</i> Informe os dados do operador
        </p>
        <form action @submit.prevent="enviarDadosSPC" class="form_padrao">
          <div class="form-row">
            <div class="form-group flutuante col-12">
              <input
                type="text"
                name="nome-operador"
                id="nome-operador"
                required
                v-model="operador.operador"
                autocomplete="off"
              />
              <label for="nome-operador">Nome do Operador</label>
            </div>
            <div class="form-group flutuante col-12">
              <input
                type="password"
                name="senha"
                id="senha"
                required
                v-model="operador.password"
                autocomplete="off"
              />
              <label for="senha">Senha</label>
            </div>
            <div class="form-group col-12">
              <button
                type="submit"
                class="btn btn-verde p-0 fit-content"
                :disabled="loading"
              >
                <span
                  class="spinner-grow spinner-grow-sm pr-2"
                  role="status"
                  aria-hidden="true"
                  v-show="loading"
                ></span>
                <span v-if="loading">Processando</span>
                <span v-else>Verificar</span>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div class="col-md-8">
      <div class="form_padrao d-none">
        <div class="form-group flutuante col-12">
          <input
            type="text"
            name="filtro"
            id="filtro-produto"
            required
            @keyup="filter"
            v-model="filterValue"
          />
          <label for="nome-operador">Pesquisar...</label>
        </div>
      </div>

      <transition mode="out-in">
        <div
          class="card card_content result shadow-sm p-4"
          v-if="servicos.length"
        >
          <h6
            class="text-left text-uppercase p-2 pb-3 d-flex align-items-center"
          >
            <i class="material-icons">list</i> Produtos Disponíveis para o
            operador
          </h6>
          <div
            class="alert alert-success border-0 shadow-sm"
            role="alert"
            v-for="servico in servicos"
            :key="servico.codigo"
          >
            {{ servico.nome }}
          </div>
        </div>
        {{ filteredValue }}
      </transition>
    </div>
  </fragment>
</template>

<script>
export default {
  name: "spc",
  data() {
    return {
      filterValue: null,
      filteredValue: null,
      servicos: [],
      detalhe: {},
      loading: false,
      error: null,
      operador: {
        operador: null,
        password: null,
        codigoProduto: null,
      },
      produto: {
        nome: "Pesquisa Serviços SPC",
        id: "SPC",
      },
      breadcrumb: [
        {
          nome: "Pesquisa Serviços SPC",
          id: "SPC",
        },
      ],
    };
  },
  methods: {
    filter() {},
    detalheProduto(idProduto) {
      this.operador.codigoProduto = idProduto;
      this.loading = true;
      this.$http
        .post("/api/Spc/DetalharProduto", this.operador)
        .then((response) => {
          if (
            response.data == "Operador ou senha inválidos. Tente novamente."
          ) {
            this.error = response.data;
          } else {
            this.detalhe = [...response.data];
          }
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          console.log(error);
        });
    },
    enviarDadosSPC() {
      this.loading = true;
      this.$http
        .post("/api/Spc/ListarProdutos", this.operador)
        .then((response) => {
          if (
            response.data == "Operador ou senha inválidos. Tente novamente."
          ) {
            this.$toast.open({
              message: response.data,
              type: "error",
            });
          } else {
            this.servicos = [...response.data];
          }
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          console.log(error);
        });
    },
  },
  created() {
    this.$store.commit("UPDATE_PRODUTO", this.produto);
    this.$store.commit("UPDATE_BREADCRUMB", this.breadcrumb);
  },
};
</script>

<style lang="scss" scoped>
.result {
  padding: 40px;
  max-height: 500px;
  overflow-y: auto;
}
</style>
